import { useState, useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import './AutoCompleteInput.css';

import { useAutoCompleteAPI } from '../../../APIs/common';
export default function AutoCompleteInput({
  value,
  onChange,
  onSelect,
  apiEndpoint,
  placeholder = 'Type to search…',
  minChars = 2,
  disabled = false
}) {
  const [typed, setTyped] = useState(value || '');
  const [isTyping, setIsTyping] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const containerRef = useRef(null);

  // Sync internal state with value prop when it changes (for controlled component behavior)
  useEffect(() => {
    if (value !== undefined && value !== typed) {
      setTyped(value || '');
      setIsTyping(false);
    }
  }, [value]);

  const { results, isLoading } = useAutoCompleteAPI(typed, isTyping, apiEndpoint);

  // clicking outside closes dropdown
  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="position-relative" ref={containerRef}>
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={typed}
        disabled={disabled}
        className="auto-input"
        onChange={(e) => {
          const text = e.target.value;
          setTyped(text);
          setIsTyping(true);
          onChange?.(text);
          setShowDropdown(true);
        }}
        onFocus={() => {
          if (typed.length >= minChars) setShowDropdown(true);
        }}
      />

      {showDropdown && (
        <div className="auto-dropdown">
          {isLoading && <div className="auto-item disabled">Searching...</div>}

          {!isLoading && results.length === 0 && typed.length >= minChars && <div className="auto-item disabled">No results</div>}

          {results.map((item) => (
            <div
              key={item.id || item.value}
              className="auto-item"
              onMouseDown={() => {
                setTyped(item.name || item.label);
                setIsTyping(false);
                setShowDropdown(false);
                onSelect?.(item);
              }}
            >
              {item.name || item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
